module.exports = __webpack_public_path__ + "assets/img/ZT2880-M.b3bdf286.png";